export const mergeArraysOfObjsBaseOnProp = (originArr, updatingArr, prop) => {
  for (var i = 0; i < originArr.length; i++) {
    for (var j = 0; j < updatingArr.length; j++) {
      if (originArr[i][prop] === updatingArr[j][prop]) {
        originArr[i] = { ...updatingArr[j], ...originArr[i] };
        updatingArr.splice(j, 1);
        break;
      }
    }
  }
  return [...originArr, ...updatingArr];
};

export const isJsonObject = (item) => {
  let value = typeof item !== "string" ? JSON.stringify(item) : item;    
  try {
    value = JSON.parse(value);
  } catch (e) {
    return false;
  }
    
  return typeof value === "object" && value !== null;
};